import React from 'react';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import Dropdown from 'components/base/Dropdown';
import {
  GRANULARITY,
  GRANULARITY_OPTIONS,
  GRANULARITY_OPTIONS_KANBAN
} from '../consts';
import { getTeamsNames, isEqualAllTeams } from './TeamsDropdown';
import { isMulti } from 'common/utils/utils';

const GranularityDropdown = props => {
  const {
    globallySelectedTeams,
    isKanbanBoard,
    selectedGranularity,
    onChange,
    isPmCustomDashboard
  } = props;

  const granularityOptions =
    (selectedGranularity !== GRANULARITY.ITERATIONS &&
      (isKanbanBoard ||
        isEqualAllTeams(globallySelectedTeams) ||
        isMulti(globallySelectedTeams))) ||
    isPmCustomDashboard
      ? GRANULARITY_OPTIONS_KANBAN
      : GRANULARITY_OPTIONS;

  return (
    <Dropdown
      key='GranularityDropdown'
      menuHeight='30rem'
      width='14rem'
      height='2.1rem'
      options={granularityOptions}
      selectedValue={selectedGranularity || 'Default'}
      onChange={granularity => {
        TrackingService.logEvent(TRACKING.EVENTS.FILTER, {
          page: TRACKING.PAGES.METRICS,
          filter_name: TRACKING.FILTER.RATE,
          team_names: getTeamsNames(globallySelectedTeams)
        });
        onChange(granularity);
      }}
      placeholder='Default'
      dataCy='granularity-drop-down'
    />
  );
};
export default GranularityDropdown;
